import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { SlideadjustmentunitpriceInfo } from 'sg-api';
import { UntypedFormGroup, FormGroupDirective, UntypedFormBuilder } from '@angular/forms';
import { SearchStat } from '../../../../../sg-kc-shared/constants/searchStat';

/**
 * 再エネ賦課金単価登録画面(承認情報)
 * @exports
 * @class Sgkc034dReEnergyTankaApprovalInfoComponent
 * @implements {OnInit, OnDestroy, OnChanges}
 */
@Component({
    selector: 'app-sgkc034d-re-energy-tanka-approval-info',
    templateUrl: './sgkc034d-re-energy-tanka-approval-info.component.html',
    styleUrl: './sgkc034d-re-energy-tanka-approval-info.component.scss'
})

export class Sgkc034dReEnergyTankaApprovalInfoComponent implements OnInit, OnDestroy, OnChanges {
    /** スライド調整単価情報 */
    @Input() slideadjustmentunitpriceInfo: SlideadjustmentunitpriceInfo;
    /** 画面モード */
    @Input() mode: string;
    /** ステータス */
    apprvStsAname = this.fb.control({ value: '', disabled: true });
    /** 登録部署 */
    regDepartmentname = this.fb.control({ value: '', disabled: true });
    /** 登録者 */
    registrantname = this.fb.control({ value: '', disabled: true });
    /** 登録日時 */
    regDateTime = this.fb.control({ value: '', disabled: true });
    /** 承認部署 */
    apprvDepartmentname = this.fb.control({ value: '', disabled: true });
    /** 承認者 */
    approvername = this.fb.control({ value: '', disabled: true });
    /** 承認日時 */
    apprvDateTime = this.fb.control({ value: '', disabled: true });
    /** スライド調整単価承認情報情報保持Form */
    reEnergyTankaApprovalInfoForm: UntypedFormGroup = this.fb.group({
        apprvStsAname: this.apprvStsAname,
        regDepartmentname: this.regDepartmentname,
        registrantname: this.registrantname,
        regDateTime: this.regDateTime,
        apprvDepartmentname: this.apprvDepartmentname,
        approvername: this.approvername,
        apprvDateTime: this.apprvDateTime,
    })
    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;

    /**
     * コンストラクタ
     * @param {FormGroupDirective} parent - 親のFormGroupDirective
     * @param {UntypedFormBuilder} fb - フォームビルダー
     * @memberof Sgkc034dReEnergyTankaApprovalInfoComponent
     */
    constructor(
        private parent: FormGroupDirective,
        private fb: UntypedFormBuilder,
    ) { }

    /** 
    * 初期処理
    * @memberof Sgkc034dReEnergyTankaApprovalInfoComponentvSgkc034dReEnergyTankaApprovalInfoComponent
    */
    ngOnInit(): void {
        this.initializeDisplay();
    }

    /** 
     * コンポーネント破棄時の処理
     * @memberof Sgkc034dReEnergyTankaApprovalInfoComponent
     */
    ngOnDestroy(): void {
        this.parentForm.clearValidators();
        this.parentForm.updateValueAndValidity();
        this.parentForm.removeControl('reEnergyTankaApprovalInfoForm');
    }

    /** 
     * 入力値変更時の処理
     * @param {any} changes - 入力値の変更内容
     * @memberof Sgkc034dReEnergyTankaApprovalInfoComponent
     */
    ngOnChanges(changes) {
        if (changes.slideadjustmentunitpriceInfo) {
            this.initializeDisplay();
        }
    }

    /** 
     * 表示の初期化処理
     * @memberof Sgkc034dReEnergyTankaApprovalInfoComponent
     */
    initializeDisplay(): void {
        // 登録日時のフォーマット
        // YYYYMMdd形式の日付を分解
        const regDateFormat = this.convertDateFormat(this.slideadjustmentunitpriceInfo.regDate);
        const regTimeFormat = this.convertTimeFormat(this.slideadjustmentunitpriceInfo.registrationtime);
        // フォーマットを作成
        const regTimeDateFormat = `${regDateFormat} ${regTimeFormat}`;

        let apprvTimeDateFormat = null;
        // 承認ステータスがが承認済の場合フォーマット
        if(this.slideadjustmentunitpriceInfo.apprvStatuscode ===  SearchStat.SHONINZUMI){

        // 承認日時のフォーマット
        const apprvDateFormat = this.convertDateFormat(this.slideadjustmentunitpriceInfo.apprvDate);
        const apprvTimeFormat = this.convertTimeFormat(this.slideadjustmentunitpriceInfo.apprvHms);
        // フォーマットを作成
        apprvTimeDateFormat = `${apprvDateFormat} ${apprvTimeFormat}`;
        }
        
        this.parentForm = this.parent.form;
        this.parentForm.addControl('reEnergyTankaApprovalInfoForm', this.reEnergyTankaApprovalInfoForm);
        // 単価表登録管理情報FormGroupに初期値を設定
        this.reEnergyTankaApprovalInfoForm.controls['apprvStsAname'].setValue(this.slideadjustmentunitpriceInfo.apprvStsAname);
        this.reEnergyTankaApprovalInfoForm.controls['regDepartmentname'].setValue(this.slideadjustmentunitpriceInfo.regDepartmentname);
        this.reEnergyTankaApprovalInfoForm.controls['registrantname'].setValue(this.slideadjustmentunitpriceInfo.registrantname);
        this.reEnergyTankaApprovalInfoForm.controls['regDateTime'].setValue(regTimeDateFormat);
        this.reEnergyTankaApprovalInfoForm.controls['apprvDepartmentname'].setValue(this.slideadjustmentunitpriceInfo.apprvDepartmentname);
        this.reEnergyTankaApprovalInfoForm.controls['approvername'].setValue(this.slideadjustmentunitpriceInfo.approvername);
        this.reEnergyTankaApprovalInfoForm.controls['apprvDateTime'].setValue(apprvTimeDateFormat);
    }

    /** 
     * 日付のフォーマット変換
     * @param {string} dateStr - 日付文字列 (YYYYMMDD形式)
     * @returns {string} - YYYY/mm/DD形式の日時文字列
     */
    convertDateFormat(dateStr: string): string {
        // YYYYMMDD形式の文字列を受け取る
        const year = dateStr.slice(0, 4);
        const month = dateStr.slice(4, 6);
        const day = dateStr.slice(6, 8);
        // YYYY/mm/DD形式に変換して返す
        return `${year}/${month}/${day}`;
    }

    /** 
     * 時刻のフォーマット変換
     * @param {string} timeStr - 時刻文字列 (HHmmss形式)
     * @returns {string} - HH:mm:ss形式の時間文字列
     */
    convertTimeFormat(timeStr: string): string {
        // HHmmss形式の文字列を受け取る
        const HH = timeStr.slice(0, 2);
        const mm = timeStr.slice(2, 4);
        const ss = timeStr.slice(4, 6);
        // HH:mm:ss形式に変換して返す
        return `${HH}:${mm}:${ss}`;
    }
}